import { render, staticRenderFns } from "./downDetail.vue?vue&type=template&id=638a7219&scoped=true&"
import script from "./downDetail.vue?vue&type=script&lang=js&"
export * from "./downDetail.vue?vue&type=script&lang=js&"
import style0 from "./downDetail.vue?vue&type=style&index=0&id=638a7219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a7219",
  null
  
)

export default component.exports